// extracted by mini-css-extract-plugin
export var accordion = "_br-0";
export var chevron = "_br-3";
export var closed = "_br-2";
export var content = "_br-4";
export var open = "_br-1";
export var rotate = "_br-5";